import { useState } from "react";
import clsx from "clsx";

import { HelpCircleSvg } from "@components/index";
import { HelpPage } from "@pages/index";

export const TutorialButton = ({
  tutorialNames,
  faqCategory,
  variant = "light",
}: {
  tutorialNames?: string[];
  faqCategory: string[];
  variant?: "light" | "dark";
}) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={clsx(
          "flex w-fit items-center gap-x-2 rounded-lg px-4 py-2",
          variant === "light"
            ? "bg-primary-108 text-white-100"
            : "bg-primary-150 text-primary-300",
        )}
        onClick={() => setDrawerOpen(true)}
      >
        <span className="text-[14px]/[24px] font-bold">Help</span>
        <HelpCircleSvg />
      </button>
      {isDrawerOpen && (
        <HelpPage
          onClose={() => setDrawerOpen(false)}
          tutorialNames={tutorialNames}
          faqCategory={faqCategory}
        />
      )}
    </>
  );
};
